import React, { useCallback, useRef, useState } from "react";
import "@/components/sections/CpfClarityExplorer.css";
import { analytics } from "@/lib/analytics";
import { TOPICS } from "@/components/sections/cpfClarityData";
import { TopicTab, TopicPanel, SourcesAside } from "@/components/sections/CpfClarityParts";
import { useRovingKeyboardNav } from "@/hooks/useRovingKeyboardNav";

const CpfClarityExplorer = ({ onRegister }) => {
  const [active, setActive] = useState(0);
  const [mythOpen, setMythOpen] = useState(false);
  const [visited, setVisited] = useState(() => new Set([0]));
  const tabRefs = useRef([]);

  const selectTopic = useCallback((index, moveFocus = false) => {
    setActive(index);
    setMythOpen(false);
    setVisited((prev) => new Set(prev).add(index));
    analytics.quizAnswer({ topic_index: index, topic: TOPICS[index].title });
    if (moveFocus && tabRefs.current[index]) tabRefs.current[index].focus();
  }, []);

  const onTabKeyDown = useRovingKeyboardNav(TOPICS.length, selectTopic, { axis: "both" });

  const topic = TOPICS[active];

  const toggleMyth = () => {
    setMythOpen((v) => {
      if (!v) analytics.mythReveal({ topic: topic.title });
      return !v;
    });
  };

  const handleCta = () => {
    analytics.primaryCtaClick({ source: "cpf-clarity", topic: topic.title });
    if (typeof onRegister === "function") onRegister();
  };

  return (
    <section className="cpf-clarity" id="cpf-clarity" aria-labelledby="cpf-clarity-title" data-testid="cpf-clarity">
      <div className="cpf-clarity__container">
        <header className="cpf-clarity__heading">
          <div>
            <p className="cpf-clarity__eyebrow">Personalise your journey</p>
            <h2 id="cpf-clarity-title">What would you like more clarity on?</h2>
          </div>
          <p className="cpf-clarity__intro">
            Choose the CPF question most relevant to you. We&rsquo;ll show you how it connects to the seminar in one focused view.
          </p>
        </header>

        <div className="cpf-clarity__explorer">
          <div className="cpf-clarity__tabs" role="tablist" aria-label="Choose a CPF topic">
            {TOPICS.map((t, i) => (
              <TopicTab
                key={t.title}
                topic={t}
                index={i}
                selected={active === i}
                visited={visited.has(i)}
                tabRef={(el) => (tabRefs.current[i] = el)}
                onSelect={() => selectTopic(i)}
                onKeyDown={(e) => onTabKeyDown(e, i)}
              />
            ))}
          </div>

          <TopicPanel topic={topic} activeIndex={active} mythOpen={mythOpen} onToggleMyth={toggleMyth} onCta={handleCta} />
        </div>

        <SourcesAside />
      </div>
    </section>
  );
};

export default CpfClarityExplorer;
